import * as React from "react";

import { ColorError } from "./theme";

export const ErrorIcon = ({
  fill,
  width,
  height,
}: {
  fill?: string;
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width || "16"}
      height={height || "16"}
      viewBox="0 0 35 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 0C14.1377 0 10.851 0.997033 8.05531 2.86502C5.25968 4.733 3.08075 7.38804 1.79406 10.4944C0.507366 13.6007 0.170709 17.0189 0.826658 20.3165C1.48261 23.6142 3.1017 26.6433 5.47919 29.0208C7.85669 31.3983 10.8858 33.0174 14.1835 33.6733C17.4812 34.3293 20.8993 33.9926 24.0056 32.706C27.112 31.4193 29.767 29.2403 31.635 26.4447C33.503 23.6491 34.5 20.3623 34.5 17C34.5 12.4913 32.7089 8.1673 29.5208 4.97918C26.3327 1.79107 22.0087 0 17.5 0ZM24.708 22.6667L23.1667 24.208L17.5 18.598L11.89 24.208L10.292 22.6667L15.902 17L10.292 11.39L11.89 9.792L17.5 15.402L23.1667 9.792L24.7647 11.39L19.098 17L24.708 22.6667Z"
        fill={fill || ColorError.main}
      />
    </svg>
  );
};
